/** 閲覧履歴・書込履歴ではヘッダー検索を表示しない。 */
export function isHistoryPath(pathname: string): boolean {
  return pathname === "/history" || pathname.startsWith("/history/");
}
